import { Box, Avatar } from '@mantine/core'

export function GlowAvatar({ src, name, size = 60, color = 'cyan', active = false, square = false }) {
  const glowColor = {
    cyan: 'rgba(0, 229, 255, 0.5)',
    green: 'rgba(0, 230, 118, 0.5)',
    teal: 'rgba(0, 191, 165, 0.5)',
    orange: 'rgba(255, 145, 0, 0.5)',
  }[color] || 'rgba(0, 229, 255, 0.5)'

  const borderRadius = square ? 6 : '50%'

  return (
    <Box
      style={{
        borderRadius,
        padding: 3,
        background: active
          ? `linear-gradient(135deg, ${glowColor}, transparent)`
          : 'rgba(255, 255, 255, 0.05)',
        boxShadow: active ? `0 0 15px ${glowColor}` : 'none',
        transition: 'all 0.3s ease',
      }}
    >
      <Avatar
        src={src}
        alt={name}
        size={size}
        radius={square ? 4 : 'xl'}
        style={{
          border: `2px solid ${active ? glowColor : 'rgba(255, 255, 255, 0.1)'}`,
        }}
      >
        {name?.[0]?.toUpperCase()}
      </Avatar>
    </Box>
  )
}
